import { gql } from '@apollo/client'
import { eventListFragment } from '~/graphql/fragments'

export const GET_POPULAR_EVENTS = gql`
  query getPopularEvents(
    $first: Int
    $after: String
    $highlighted: Boolean
    $period: Period
    $date: DateTime
    $category: EventCategory
    $cityId: ID
    $locationId: ID
    $nearby: GeopointFilter
  ) {
    activeEvents(
      first: $first
      after: $after
      period: $period
      date: $date
      orderBy: { field: BOOST_VALUE, direction: DESC }
      filter: {
        locationId: $locationId
        category: $category
        highlighted: $highlighted
        city: $cityId
        nearby: $nearby
      }
    ) {
      period
      edges {
        node {
          ...eventList
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${eventListFragment}
`
